import ToggleSwitch from 'components/toggleSwitch/ToggleSwitch'
import * as React from 'react'
import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {updateShift} from 'redux/slices/shiftSlice'
import CustomButton, {
  DangerButton,
  OutlinedButton,
} from '../../../components/CustomButton'
import CustomTable, {
  TableCell,
  TableHeader,
  TableRow,
} from '../../../components/table/CustomTable'
import {utcToLocalTimeString} from '../../../helpers/dateTimeHelper'
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import {isEmpty} from "lodash";
import CustomTableItemLoader from "../../../components/CustomTableItemLoader";
import { getShifts } from 'redux/slices/shiftSlice'

const ShiftList = ({onRemove, onEdit, onPreviewBookings}) => {
  const {shifts, loading, error} = useSelector((state) => state.shifts)

  return (
    <>
      <CustomTable>
        <ShiftTableHeader shiftList={shifts}/>

        <ShiftTableList
          shiftList={shifts}
          loading={loading}
          onRemove={onRemove}
          onEdit={onEdit}
          onPreviewBookings={onPreviewBookings}
          error={error}
        />
      </CustomTable>
    </>
  )
}

const ShiftTableHeader = () => {
  const Headers = ['Shift', 'Start Time', 'End Time', 'State']

  const MapHeaders = Headers.map((value, index) => {
    return (
      <TableHeader
        key={index}
      >
        {value}
      </TableHeader>
    )
  })

  return (
    <>
      <thead>
      <TableRow>{MapHeaders}</TableRow>
      </thead>
    </>
  )
}

const ShiftTableList = ({
                          shiftList = [],
                          loading = false,
                          onRemove,
                          onEdit,
                          onPreviewBookings,
                          error
                        }) => {
  const dispatch = useDispatch()

  const shiftListMap = shiftList.map((shift) => (
    <TableRow key={shift.id}>
      <TableCell isActive={!shift?.disabled}>
        {capitalizeFirstLetter(shift?.name)}
      </TableCell>
      <TableCell isActive={!shift?.disabled}>{utcToLocalTimeString(shift?.start_time)}
      </TableCell>
      <TableCell isActive={!shift?.disabled}>
        {utcToLocalTimeString(shift?.end_time)}
      </TableCell>
      <TableCell>
        <ToggleSwitch
          isChecked={!shift?.disabled}
          onChange={() => {
            dispatch(
              updateShift({shiftId: shift.id, data: {disabled: !(shift?.disabled)}}),
            )
          }}
        />
      </TableCell>

      <TableCell>
        <div className="flex space-x-4 justify-end">
          <OutlinedButton onClick={() => onPreviewBookings(shift)}>
            View Bookings
          </OutlinedButton>
          <CustomButton onClick={() => onEdit(shift)}>Edit</CustomButton>
        </div>
      </TableCell>
    </TableRow>
  ))

  return (
    <>
      {loading || isEmpty(shiftList) || error.length > 0
        ? <CustomTableItemLoader
          loading={loading}
          error={error}
          isEmpty={isEmpty(shiftList)}
          count={10}
          colSpan={4}
          key="shift-list"
          retry={() => {
            dispatch(getShifts())
          }}
        />
        :
        <tbody>{shiftListMap}</tbody>}
    </>
  )
}

export default ShiftList
